import DataBag from 'utils/DataBag';

/**
 * Review type class
 */
class Review extends DataBag {

    /**
     * Gets the guest's overall score
     *
     * @example 8.1
     *
     * @returns {number}
     */
    getScore = () => this.get('overallScore');

    /**
     * Gets the first name of the of the reviewer
     *
     * @example "Jeff"
     *
     * @returns {string}
     */
    getGuestName = () => this.get('firstName');

    /**
     * Gets the general text the user wrote in their review
     *
     * @example "Extremely kind owners with amazing..."
     *
     * @returns {string}
     */
    getTextGeneral = () => this.get('textGeneral', '');

    /**
     * Gets the "pros" the user wrote in their review
     *
     * @example "I liked the swimming pool and the free breakfast"
     *
     * @returns {string}
     */
    getTextPositive = () => this.get('textPositive', '');

    /**
     * Gets the "cons" the user wrote in their review
     *
     * @example "The breakfast was overpriced and the the swimming pool was closed."
     *
     * @returns {string}
     */
    getTextNegative = () => this.get('textNegative', '');

    /**
     * Gets the name of the traveler type
     *
     * @example "Couple"
     *
     * @returns {string}
     */
    getTravelerTypeName = () => {
        return this.get('travelerType').name === null ? '' : this.get('travelerType').name.replace('Traveling as ', '');
    };

    /**
     * Gets id of the the traveler type
     *
     * @example 8016
     *
     * @returns {number}
     */
    getTravelerTypeId = () => this.get('travelerType').id;

    /**
     * Gets the source of the review
     *
     * @example "priceline" (apparently all reviews are from priceline currently)
     *
     * @returns {string}
     */
    getSource = () => 'priceline';

    /**
     * Gets the date the review was submitted using locale conventions
     *
     * @example "1/20/2017"
     *
     * @returns {string}
     */
    getDate = () => {
        const creationDate = new Date(this.get('creationDate'));
        // Checking if date is valid. This might be overkill but currently we're getting an invalid date back as of this writing. Plus it can't hurt (I hope).
        // https://stackoverflow.com/questions/1353684/detecting-an-invalid-date-date-instance-in-javascript
        if (Reflect.apply(Object.prototype.toString, creationDate, []) === '[object Date]') {
            // it is a date
            if (isNaN(creationDate.getTime())) {
                return '';
            }

            return creationDate.toLocaleDateString('en-US');
        }

        return '';
    };
}

export default Review;
